import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = (theme) => ({});

function InstructorPollResume(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [loading, setLoading] = React.useState(false);

  function resumePoll() {
    setLoading(true);
    props.resume().then(() => {
      setLoading(false);
      props.openCtl(false);
    });
  }

  return (
    <Dialog
      fullScreen={mobile}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Resume Poll " + props.pollNumber + "?"}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Resuming this poll will allow students to vote again.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            props.openCtl(false);
          }}
        >
          Cancel
        </Button>

        <Button color="primary" onClick={resumePoll}>
          resume
        </Button>
      </DialogActions>
      {loading ? <LinearProgress /> : null}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorPollResume))
  )
);
